import type { ReactNode } from 'react';
import './PillGroup.css';

export type PillOption<T extends string = string> = {
  value: T;
  label: ReactNode;
};

export type PillGroupProps<T extends string = string> = {
  options: PillOption<T>[];
  value: T;
  onChange: (value: T) => void;
  ariaLabel?: string;
  className?: string;
};

export default function PillGroup<T extends string = string>({
  options,
  value,
  onChange,
  ariaLabel,
  className = '',
}: PillGroupProps<T>) {
  return (
    <div
      className={`pill-group${className ? ` ${className}` : ''}`}
      role="tablist"
      aria-label={ariaLabel}
    >
      {options.map((option) => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`pill-group__pill${isActive ? ' pill-group__pill--active' : ''}`}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
